import React from 'react';
import { TimezoneMode } from '../../utils/timezone';

interface TimezoneControlProps {
  timezone: TimezoneMode;
  onTimezoneChange: (tz: TimezoneMode) => void;
}

const TimezoneControl: React.FC<TimezoneControlProps> = ({ timezone, onTimezoneChange }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: '8px 0',
      marginBottom: '12px',
      gap: '12px',
      flexShrink: 0
    }}>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <span style={{ color: '#94a3b8', fontSize: '12px', fontWeight: 600 }}>TIMEZONE:</span>
        <button
          onClick={() => onTimezoneChange('UTC')}
          style={{
            padding: '6px 12px',
            background: timezone === 'UTC' ? 'rgba(139, 92, 246, 0.4)' : 'rgba(71, 85, 105, 0.2)',
            border: timezone === 'UTC' ? '1px solid rgba(139, 92, 246, 0.6)' : '1px solid rgba(139, 92, 246, 0.3)',
            borderRadius: '4px',
            color: '#e2e8f0',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: timezone === 'UTC' ? 700 : 600
          }}
          title="Show times in UTC"
        >
          UTC
        </button>
        <button
          onClick={() => onTimezoneChange('Local')}
          style={{
            padding: '6px 12px',
            background: timezone === 'Local' ? 'rgba(139, 92, 246, 0.4)' : 'rgba(71, 85, 105, 0.2)',
            border: timezone === 'Local' ? '1px solid rgba(139, 92, 246, 0.6)' : '1px solid rgba(139, 92, 246, 0.3)',
            borderRadius: '4px',
            color: '#e2e8f0',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: timezone === 'Local' ? 700 : 600
          }}
          title="Show times in local timezone"
        >
          Local
        </button>
      </div>
    </div>
  );
};

export default TimezoneControl;

